import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { Button } from "@/components/ui/button";
import { CalendarBlank } from "@phosphor-icons/react";
import { format } from "date-fns";
import { useState } from "react";

export function DatePicker({ value, onChange, testId }) {
  const [open, setOpen] = useState(false);
  const selected = value ? new Date(value + "T00:00:00") : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen} modal={true}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          data-testid={testId}
          className="w-full justify-start bg-secondary/50 border-border text-left font-normal hover:bg-secondary"
        >
          <CalendarBlank className="mr-2 h-4 w-4 text-primary" weight="bold" />
          {selected ? format(selected, "PPP") : <span className="text-muted-foreground">Pick a date</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-popover border-border">
        <Calendar
          mode="single"
          selected={selected}
          onSelect={(d) => { if (d) { onChange(format(d, "yyyy-MM-dd")); setOpen(false); } }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
